import { useEffect, useState } from 'react';
import { Skeleton, Flex } from '@chakra-ui/react';
import { api } from '@/lib';

export function ConsultationPatientPage() {
  const rawParams = new URLSearchParams(window.location.search);
  const parsedParams = Object.fromEntries(rawParams.entries());
  const [loading, setLoading] = useState<boolean>(false);
  const [roomJitsi, setRoomJitsi] = useState({
    token: null,
    roomName: null,
  });

  const GetRoomJitsi = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(
        `consulta/Token-Jitsi?consultaId=${parsedParams.consultaId}`,
      );
      setRoomJitsi(data.data);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!roomJitsi.token) GetRoomJitsi();
  }, []);

  return loading || !roomJitsi.token ? (
    <Skeleton mt="8" w="100%" h="600px" border="20px" />
  ) : (
    <Flex h="100vh" justify="center" align="start">
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <iframe
        srcDoc={`<html>
              <head>
                <script src='https://8x8.vc/vpaas-magic-cookie-c72b0ade439b4dadb483e7ca0e46941c/external_api.js' async></script>
                <style>html, body, #jaas-container { height: 100%; }</style>
                <script type="text/javascript">
                  window.onload = () => {
                    const api = new JitsiMeetExternalAPI("8x8.vc", {
                      roomName:"${roomJitsi?.roomName}",
                      parentNode: document.querySelector('#jaas-container'),
                      jwt: '${roomJitsi.token}'
                    });

                    api.addListener('participantLeft', participant => { 
                      window.location.reload();
                    });

                    return () => {
                      api.removeListener('participantLeft');
                    };
                  }
                </script>
              </head>
              <body><div id="jaas-container" /></body>
            </html>`}
        width="100%"
        height="100%"
      />
    </Flex>
  );
}
